import React, { Component } from 'react';
import { withDomains, RESTExecutor } from '../../../lib/domain';
import { Row, Table, Button, Divider, Input } from 'antd';
import Title from 'antd/lib/typography/Title';
import { formatMoney } from '../../../lib/util';

const actions_cols = () => [
    {
        title: "Action Name",
        dataIndex: "name",
        key: 'name'
    },
    // {
    //     title: "Version",
    //     dataIndex: 'version',
    //     key: 'version'
    // },
    {
        title: "Action ID",
        dataIndex: 'id',
        key: 'id'
    }
]
class UnreconciledActionsView extends Component {
    constructor(props) {
        super(props)
    
        this.state = {
            form_visibility: false,
            form_data: {},
            edit_id: null
        };
        this.list_smartactions = RESTExecutor.list().config({
            label: 'unreconciled_actions',
        }).connect(props.domains.plugins);
    
    
        console.log("constructed")
    };
    
    
    render() {
    
        let list_smartactions_res = this.list_smartactions.response();
        let list_smartactions_data = list_smartactions_res.result || {};
    
    
        let rowsMeta=list_smartactions_res.meta||{};
        let rowsData = list_smartactions_data.rows || [];
        let filteredData=JSON.parse(JSON.stringify(rowsData));
        if(this.state.query){
            filteredData=filteredData.filter(({ name="",id="",description="" }) => {
                name = name.toLowerCase();
                id=id.toLowerCase();
                description=description.toLowerCase();
                return name.includes(this.state.query.toLowerCase())
                ||id.includes(this.state.query.toLowerCase())
                ||description.includes(this.state.query.toLowerCase())
                ;
            });
        }
    
        return (
            <div>
                <Table
                loading={list_smartactions_res.fetching}
                scroll={{x:true}}
                    columns={actions_cols({
                    })}
                    pagination={{
                        showTotal:(total,range)=>`${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${formatMoney(total,0)} items`
                        }}
                    dataSource={filteredData}
                    className='main-table'                    size='small'
                    title={() => <div><Row type='flex' justify='space-between' style={{
                        alignItems: 'center'
                    }}><Title
                        type='secondary'
                        level={3}
    
                        style={{
                            margin: 0
                        }}>Unreconciled Actions List</Title>
                       
                    </Row><br></br>
                    <Row type='flex'
                    justify='space-between'
                    style={{
                    alignItems: 'center',
                    flexWrap: 'nowrap'
                }}>
                        <Input.Search
                            placeholder="Search For"
                            style={{
                        }} autoFocus
                            value={this.state.query}
                            onChange={(e) => {
                                this.setState({query:e.target.value})
                            }}
                           /> {this.state.query && this.state.query.length > 0 && <Button
                            style={{
                            marginLeft: 4
                        }}
                            type='danger'
                            shape="circle"
                            icon="close-circle"
                            onClick={() => {
                            this.setState({query:null})
                        }}/>}
                    </Row></div>}
                    rowKey={(record) => record.id}
                />
            </div>
        )
    }

componentDidMount() {
    this.list_smartactions.execute()
}
}


export default withDomains(UnreconciledActionsView,"plugins");
